import { getInvestmentProgramNames } from './getInvestmentProgramNames';

export async function getProgramName(
  data: any
): Promise<string | string[] | null> {
  if (
    data?.content?.component === 'programPage' ||
    data?.content?.component === 'pageProgram' ||
    data?.content?.component === 'factsheet' ||
    data?.content?.component === 'price'
  ) {
    return data?.name ?? data?.content?.name ?? data?.content?.heading ?? null;
  }
  if (data?.content?.investmentProgram) {
    return await getInvestmentProgramNames(data?.content?.investmentProgram);
  }
  return data?.content?.programName ?? null;
}
